(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-section"] && !Shopify.designMode) return;
  try {
    
  class Carousel {
    constructor(element) {
      this.track = element;
      this.prevButton = element.parentElement.querySelector('.carousel-nav--prev button');
      this.nextButton = element.parentElement.querySelector('.carousel-nav--next button');

      this.initButtons();
    }

    initButtons() {
      this.prevButton.addEventListener('click', () => this.scroll('left'));
      this.nextButton.addEventListener('click', () => this.scroll('right'));
    }

    scroll(direction) {
      const scrollAmount = this.track.offsetWidth * 0.8;
      const scrollPosition =
        direction === 'left' ? this.track.scrollLeft - scrollAmount : this.track.scrollLeft + scrollAmount;

      this.track.scrollTo({
        left: scrollPosition,
        behavior: 'smooth',
      });
    }
  }

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    new Carousel(carousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map"]) return;
  try {
    
  if (Shopify.designMode) {
    let lastSectionId = null;

    const handleSection = (sectionId) => {
      const section = document.querySelector(`#shopify-section-${sectionId}`);
      if (!section) return;

      const jsonDom = document.querySelector(`*[data-id="${sectionId}"]`);
      if (!jsonDom) return;
      const json = JSON.parse(jsonDom.innerHTML);
      if (!json) return;

      if (json.length) {
        try {
          const newBounds = new google.maps.LatLngBounds();
          json.map((j) => {
            const { marker } = markers.find((marker) => marker.blockId === j.blockId);
            if (marker) {
              newBounds.extend(marker.position);
              marker.setIcon(image_selected);
            } else {
              const newMakrer = { ...j };
              window.markers.push(newMakrer);
              createMarker(newMakrer, i);
            }
          });

          map && map.fitBounds(newBounds);
          map.setZoom(map.getZoom() - 1);
        } catch (e) {}
      }
    };

    const cleanMarkers = () => {
      window.markers.forEach(({ marker }) => {
        marker && marker.setIcon(image);
      });
    };

    const setBounds = () => {
      map && map.fitBounds(bounds);
      map && map.setZoom(map.getZoom() - 1);
    };

    document.addEventListener('shopify:section:load', function (event) {
      const { sectionId, blockId } = event.detail;
      if (!blockId && document.querySelector(`*[data-id="${sectionId}"]`)) {
        cleanMarkers();
        setBounds();
        handleSection(sectionId);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const { sectionId, blockId } = event.detail;
      if (!blockId && document.querySelector(`*[data-id="${sectionId}"]`)) {
        const json = JSON.parse(document.querySelector(`*[data-id="${sectionId}"]`).innerHTML);
        json.forEach((j) => {
          const { marker } = markers.find((marker) => marker.blockId === j.blockId);
          marker && marker.setMap(null);
          window.markers = window.markers.filter((marker) => marker.blockId !== j.blockId);
        });
      }

      cleanMarkers();
      setBounds();
    });

    document.addEventListener('shopify:section:select', function (event) {
      const { sectionId, blockId } = event.detail;

      if (!blockId && document.querySelector(`*[data-id="${sectionId}"]`)) {
        cleanMarkers();
        setBounds();
        handleSection(sectionId);
      }
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      cleanMarkers();
    });

    document.addEventListener('shopify:block:select', function (event) {
      cleanMarkers();
      setBounds();

      const { blockId } = event.detail;
      if (!blockId) return;

      const { marker } = window.markers.find((marker) => {
        console.log('marker', marker.blockId === blockId, marker);
        return marker.blockId === blockId;
      });

      if (marker) {
        const boundsSeek = new google.maps.LatLngBounds();
        boundsSeek.extend(marker.position);
        console.log('boundsSeek', boundsSeek);
        map.fitBounds(boundsSeek);
        map.setZoom(map.getZoom() - 2);
        google.maps.event.trigger(map, 'resize');
      }
    });

    document.addEventListener('shopify:block:load', function (event) {
      const { sectionId, blockId } = event.detail;

      if (!blockId && document.querySelector(`*[data-id="${sectionId}"]`)) {
        cleanMarkers();
        setBounds();
        handleSection(sectionId);
      }
      console.log('block loaded', !blockId && document.querySelector(`*[data-id="${sectionId}"]`));
    });
  }

  } catch(e) { console.error(e); }
})();
})();
